var map = {
	"./add-icon.svg": "4ba4",
	"./applyMenu.svg": "60ba",
	"./applyicon.svg": "e360",
	"./call-center.svg": "57a8",
	"./delete-icon.svg": "43f1",
	"./done-icon.svg": "c857",
	"./download-icon.svg": "1066",
	"./editor-icon.svg": "e9e4",
	"./email-icon.svg": "cd2a",
	"./export-icon.svg": "2333",
	"./handleMenu.svg": "fb1c",
	"./home-icon.svg": "17fd",
	"./homeMenu.svg": "5592",
	"./issueMenu.svg": "75de",
	"./login-icon.svg": "d818",
	"./login-iocn.svg": "ea4c",
	"./logout-icon.svg": "fb07",
	"./lower-add.svg": "fe40",
	"./msg-icon.svg": "7e64",
	"./newsMenu.svg": "230e6",
	"./out-icon.svg": "3a30",
	"./phone-icon.svg": "9862",
	"./query-icon.svg": "f050",
	"./seal-icon.svg": "a17d",
	"./statisticsMenu.svg": "b715",
	"./sysMenu.svg": "4004",
	"./tCiqMenu.svg": "78e5",
	"./tbCertMenu.svg": "57ea",
	"./todo-icon.svg": "88a0",
	"./update-icon.svg": "4298",
	"./uploade-icon.svg": "e126",
	"./user-icon.svg": "3bea",
	"./watchMenu.svg": "88a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";